import * as React from 'react';
import { Checkbox } from '../Checkbox/Checkbox';
import { Radio as SemanticRadio } from 'semantic-ui-react';


var Radio = function (_a) {
    var type = _a.type, as = _a.as, checked = _a.checked, className = _a.className, defaultChecked = _a.defaultChecked, disabled = _a.disabled, id = _a.id, label = _a.label, name = _a.name, onChange = _a.onChange, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, tabIndex = _a.tabIndex, value = _a.value, toggle = _a.toggle;
    if (type !== 'radio') {
        return (React.createElement(Checkbox, { type: "checkbox", as: as, checked: checked, className: className, defaultChecked: defaultChecked, disabled: disabled, id: id, label: label, name: name, onChange: onChange, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, tabIndex: tabIndex, value: value, toggle: toggle }));
    }
    var classNames = ['pluggy', 'Radio'];
    if (checked) {
        classNames.push('checked');
    }
    if (disabled) {
        classNames.push('disabled');
    }
    if (className) {
        classNames.push(className);
    }
    var combinedClassNames = classNames.join(' ');
    return (React.createElement(SemanticRadio, { type: "radio", as: as, checked: checked, className: combinedClassNames, defaultChecked: defaultChecked, disabled: disabled, id: id, label: label, name: name, onChange: onChange, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, tabIndex: tabIndex, value: value }));
};
export { Radio };
